import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { ReviewOpsWorkspaceRouterState, ReviewOpsWorkspaceTab } from 'src/app/workspace-tabs';

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/layout.sidebar/view.scss */
/* src/app/layout.sidebar/view.scss: no such file or directory */`],
})
export class LayoutSidebarComponent implements OnInit, OnDestroy {
    public sidebarCollapsed: boolean = false;
    public workspaceTabs: ReviewOpsWorkspaceTab[] = [];
    public activeWorkspaceTabId: string = '';
    public workspaceSwitchingTabId: string = '';
    public workspaceTabsHidden: boolean = false;
    public draggingWorkspaceTabId: string = '';
    public workspaceDragOverTabId: string = '';
    public workspaceTabCodexCounts: any = {};
    public workspaceTabReloading: boolean = false;
    private readonly sidebarStorageKey: string = 'reviewops.sidebar.collapsed';
    private readonly workspaceTabsStorageKey: string = 'reviewops.workspace.tabs.v1';
    private readonly workspaceActiveTabStorageKey: string = 'reviewops.workspace.active-tab.v1';
    private readonly workspaceTabsHiddenStorageKey: string = 'reviewops.workspace.tabs.hidden';
    private readonly workspaceTabCodexCountsStorageKey: string = 'reviewops.workspace.tab-codex-counts.v1';
    private readonly workspaceTabCodexCountsEnabled: boolean = false;
    private readonly workspaceTabCodexPollIntervalMs: number = 30000;
    private readonly workspaceTabCodexCountsCacheMs: number = 60000;
    private headerResizeObserver?: ResizeObserver;
    private headerMutationObserver?: MutationObserver;
    private workspaceTabbarResizeObserver?: ResizeObserver;
    private observedHeader?: Element | null;
    private observedWorkspaceTabbar?: Element | null;
    private headerMeasureFrame?: number;
    private viewportMeasureFrame?: number;
    private workspaceLayoutFrame?: number;
    private workspaceTitleTimer?: number;
    private workspaceTabCodexPollTimer?: number;
    private workspaceSwitchVisualTimer?: number;
    private workspaceDragOrderFrame?: number;
    private routeSubscription: any = null;
    private switchingWorkspaceTabs: boolean = false;
    private workspaceTabCodexPolling: boolean = false;
    private workspaceTabCodexLastFetchAt: number = 0;
    private workspaceTabCodexLastFetchKey: string = '';
    private destroyed: boolean = false;
    private workspaceSwitchVisualStartedAt: number = 0;
    private readonly workspaceSwitchVisualMinMs: number = 180;
    private readonly workspaceDragStartThresholdPx: number = 4;
    private readonly viewportChangeHandler = () => this.scheduleViewportHeightSync();
    private workspaceDragPointerId: number | null = null;
    private workspaceDragCandidateTabId: string = '';
    private workspaceDragStartX: number = 0;
    private workspaceDragStartY: number = 0;
    private workspaceSuppressTabClickId: string = '';

    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) {
        this.sidebarCollapsed = this.loadSidebarCollapsed();
        this.workspaceTabsHidden = this.loadWorkspaceTabsHidden();
    }

    public async ngOnInit() {
        this.sidebarCollapsed = this.loadSidebarCollapsed();
        this.workspaceTabsHidden = this.loadWorkspaceTabsHidden();
        this.workspaceTabCodexCounts = this.workspaceTabCodexCountsEnabled ? this.loadWorkspaceTabCodexCounts() : {};
        this.initializeWorkspaceTabs();
        this.pruneWorkspaceTabCodexCounts();
        await this.service.init();
        await this.service.status.toggle('navbar', false);
        this.routeSubscription = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                await this.handleWorkspaceNavigationEnd(event.urlAfterRedirects || event.url || this.currentWorkspaceUrl());
            }
        });
        this.installViewportHeightSync();
        this.installHeaderSpacingSync();
        this.scheduleWorkspaceLayoutSync();
        await this.service.render();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
        this.scheduleWorkspaceTitleSync();
        if (this.workspaceTabCodexCountsEnabled) {
            this.scheduleWorkspaceTabCodexStatusPoll(!Object.keys(this.workspaceTabCodexCounts || {}).length);
        } else {
            this.clearWorkspaceTabCodexCountsState(false);
        }
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.headerMeasureFrame) window.cancelAnimationFrame(this.headerMeasureFrame);
        if (this.viewportMeasureFrame) window.cancelAnimationFrame(this.viewportMeasureFrame);
        if (this.workspaceLayoutFrame) window.cancelAnimationFrame(this.workspaceLayoutFrame);
        if (this.workspaceTitleTimer) window.clearTimeout(this.workspaceTitleTimer);
        if (this.workspaceSwitchVisualTimer) window.clearTimeout(this.workspaceSwitchVisualTimer);
        if (this.workspaceDragOrderFrame) window.cancelAnimationFrame(this.workspaceDragOrderFrame);
        this.clearWorkspaceTabCodexStatusPoll();
        if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
        if (this.workspaceTabbarResizeObserver) this.workspaceTabbarResizeObserver.disconnect();
        if (this.headerMutationObserver) this.headerMutationObserver.disconnect();
        if (this.routeSubscription && this.routeSubscription.unsubscribe) this.routeSubscription.unsubscribe();
        this.routeSubscription = null;
        const visualViewport = (window as any).visualViewport;
        if (visualViewport) {
            visualViewport.removeEventListener('resize', this.viewportChangeHandler);
            visualViewport.removeEventListener('scroll', this.viewportChangeHandler);
        }
    }

    @HostListener('document:click')
    public async clickout() {
        if (!this.service.status.navbar) return;
        await this.service.status.toggle('navbar', false);
        await this.service.render();
    }

    @HostListener('document:visibilitychange')
    public onDocumentVisibilityChange() {
        if (this.documentHidden()) {
            this.clearWorkspaceTabCodexStatusPoll();
            return;
        }
        const projectIds = this.workspaceTabProjectIds();
        this.scheduleWorkspaceTabCodexStatusPoll(!this.workspaceTabCodexCacheFresh(projectIds));
    }

    public async openMobileSidebar(event?: Event) {
        if (event) event.stopPropagation();
        await this.service.status.toggle('navbar', true);
        await this.service.render();
    }

    public async closeMobileSidebar(event?: Event) {
        if (event) event.stopPropagation();
        if (!this.service.status.navbar) return;
        await this.service.status.toggle('navbar', false);
        await this.service.render();
    }

    @HostListener('window:resize')
    @HostListener('window:orientationchange')
    public windowSizeChanged() {
        this.scheduleViewportHeightSync();
        this.scheduleHeaderSpacingSync();
        this.scheduleWorkspaceLayoutSync();
    }

    @HostListener('window:reviewops-workspace-url-change', ['$event'])
    public async workspaceUrlChanged(event: any) {
        const detail = event && event.detail ? event.detail : {};
        const url = this.normalizeWorkspaceEventUrl(detail.url);
        if (!url) return;
        await this.updateActiveWorkspaceTabUrl(url);
    }

    @HostListener('document:pointermove', ['$event'])
    public moveWorkspaceTabDrag(event: PointerEvent) {
        if (!this.workspaceDragCandidateTabId || this.workspaceDragPointerId !== event.pointerId) return;
        const deltaX = event.clientX - this.workspaceDragStartX;
        const deltaY = event.clientY - this.workspaceDragStartY;
        if (!this.draggingWorkspaceTabId) {
            const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            if (distance < this.workspaceDragStartThresholdPx) return;
            this.draggingWorkspaceTabId = this.workspaceDragCandidateTabId;
            this.workspaceDragOverTabId = '';
            this.applyWorkspaceTabOrderStyles();
        }

        event.preventDefault();
        this.autoScrollWorkspaceTabs(event.clientX);
        const insertIndex = this.workspaceTabInsertIndexForClientX(event.clientX);
        if (insertIndex < 0) return;
        if (this.reorderWorkspaceTabToIndex(this.draggingWorkspaceTabId, insertIndex)) {
            this.persistWorkspaceTabs();
            this.applyWorkspaceTabOrderStyles();
        }
    }

    @HostListener('document:pointerup', ['$event'])
    @HostListener('document:pointercancel', ['$event'])
    public async finishWorkspaceTabDrag(event: PointerEvent) {
        if (!this.workspaceDragCandidateTabId || this.workspaceDragPointerId !== event.pointerId) return;
        const draggedTabId = this.draggingWorkspaceTabId;
        this.workspaceDragPointerId = null;
        this.workspaceDragCandidateTabId = '';
        this.workspaceDragStartX = 0;
        this.workspaceDragStartY = 0;
        this.draggingWorkspaceTabId = '';
        this.workspaceDragOverTabId = '';
        if (!draggedTabId) return;
        this.workspaceSuppressTabClickId = draggedTabId;
        window.setTimeout(() => {
            if (this.workspaceSuppressTabClickId === draggedTabId) this.workspaceSuppressTabClickId = '';
        }, 0);
        this.persistWorkspaceTabs();
        this.applyWorkspaceTabOrderStyles();
        await this.service.render();
    }

    public layoutShellClass() {
        const collapsedClass = this.sidebarCollapsed ? 'reviewops-sidebar-collapsed' : 'reviewops-sidebar-expanded';
        const tabsClass = this.workspaceTabsHidden ? 'reviewops-workspace-tabs-hidden' : 'reviewops-workspace-tabs-on';
        return `reviewops-layout-shell ${collapsedClass} ${tabsClass} min-h-0 bg-[#e8edf3] overflow-hidden`;
    }

    public desktopSidebarClass() {
        const widthClass = this.sidebarCollapsed ? 'lg:w-20' : 'lg:w-56';
        return `reviewops-desktop-sidebar hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col transition-all duration-200 ease-out ${widthClass}`;
    }

    public desktopSidebarInnerClass() {
        const paddingClass = this.sidebarCollapsed ? 'px-2' : 'px-3';
        return `flex grow flex-col overflow-y-auto border-r border-[#1d314f] bg-[#0f1f35] pb-3 text-slate-100 shadow-[6px_0_18px_rgba(15,31,53,0.18)] transition-all duration-200 ease-out ${paddingClass}`;
    }

    public contentClass() {
        const paddingClass = this.sidebarCollapsed ? 'lg:pl-20' : 'lg:pl-56';
        return `reviewops-layout-content reviewops-workspace-shell h-full ${paddingClass}`;
    }

    public workspaceContentClass() {
        const classes = ['reviewops-workspace-content'];
        if (this.workspaceSwitchingTabId) classes.push('is-switching-tabs');
        return classes.join(' ');
    }

    public workspaceTabsListClass() {
        const classes = ['reviewops-workspace-tabs-list'];
        if (this.draggingWorkspaceTabId) classes.push('is-reordering');
        return classes.join(' ');
    }

    public async toggleDesktopSidebar(event?: Event) {
        if (event) event.stopPropagation();
        this.sidebarCollapsed = !this.sidebarCollapsed;
        this.saveSidebarCollapsed();
        await this.service.render();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public isActiveWorkspaceTab(tab: ReviewOpsWorkspaceTab) {
        return !!tab && tab.id === this.activeWorkspaceTabId;
    }

    public trackWorkspaceTab(index: number, tab: ReviewOpsWorkspaceTab) {
        return tab.id;
    }

    public workspaceTabShellClass(tab: ReviewOpsWorkspaceTab) {
        const classes = ['reviewops-workspace-tab'];
        if (this.isActiveWorkspaceTab(tab)) classes.push('is-active');
        if (this.isSwitchingWorkspaceTab(tab)) classes.push('is-switching');
        if (this.isDraggingWorkspaceTab(tab)) classes.push('is-dragging');
        return classes.join(' ');
    }

    public workspaceTabButtonClass(tab: ReviewOpsWorkspaceTab) {
        return this.isActiveWorkspaceTab(tab)
            ? 'reviewops-workspace-tab-button is-active'
            : 'reviewops-workspace-tab-button';
    }

    public workspaceTabIconClass(tab: ReviewOpsWorkspaceTab) {
        const url = tab && tab.url ? tab.url : '';
        if (url.indexOf('/admin') === 0) return 'fa-solid fa-gear';
        if (url.indexOf('/account') === 0) return 'fa-solid fa-user';
        if (url.indexOf('/reviews/task') === 0) return 'fa-regular fa-clock';
        if (url.indexOf('/reviews') === 0) return 'fa-regular fa-circle-check';
        if (this.isProjectDetailUrl(url)) return 'fa-solid fa-diagram-project';
        return 'fa-regular fa-folder-open';
    }

    public workspaceTabCodexCount(tab: ReviewOpsWorkspaceTab) {
        if (!this.workspaceTabCodexCountsEnabled) return { total: 0, running: 0, queued: 0 };
        const projectId = this.workspaceProjectIdFromUrl(tab && tab.url ? tab.url : '');
        const count = projectId ? (this.workspaceTabCodexCounts[projectId] || {}) : {};
        return {
            total: this.workspaceCodexCountValue(count.total),
            running: this.workspaceCodexCountValue(count.running),
            queued: this.workspaceCodexCountValue(count.queued)
        };
    }

    public workspaceTabCodexTotal(tab: ReviewOpsWorkspaceTab) {
        return this.workspaceTabCodexCount(tab).total;
    }

    public workspaceTabCodexBadgeLabel(tab: ReviewOpsWorkspaceTab) {
        const total = this.workspaceTabCodexTotal(tab);
        return total > 99 ? '99+' : String(total);
    }

    public workspaceTabCodexBadgeTitle(tab: ReviewOpsWorkspaceTab) {
        const count = this.workspaceTabCodexCount(tab);
        return `에이전트 진행 ${count.running.toLocaleString('ko-KR')} · 대기 ${count.queued.toLocaleString('ko-KR')}`;
    }

    public workspaceTabOrder(tab: ReviewOpsWorkspaceTab) {
        const index = this.workspaceTabs.findIndex((item: ReviewOpsWorkspaceTab) => item.id === tab.id);
        return Math.max(index, 0) * 2;
    }

    public workspaceAddButtonOrder() {
        return this.workspaceTabs.length * 2;
    }

    public isDraggingWorkspaceTab(tab: ReviewOpsWorkspaceTab) {
        return !!tab && !!this.draggingWorkspaceTabId && tab.id === this.draggingWorkspaceTabId;
    }

    public isDragOverWorkspaceTab(tab: ReviewOpsWorkspaceTab) {
        return !!tab && !!this.workspaceDragOverTabId && tab.id === this.workspaceDragOverTabId;
    }

    public isSwitchingWorkspaceTab(tab: ReviewOpsWorkspaceTab) {
        return !!tab && !!this.workspaceSwitchingTabId && tab.id === this.workspaceSwitchingTabId;
    }

    public prepareWorkspaceTabDrag(tab: ReviewOpsWorkspaceTab, event?: PointerEvent) {
        if (!tab) return;
        if (event) {
            if (event.button !== 0) return;
            const target = event.target as Element | null;
            if (target && target.closest('.reviewops-workspace-tab-close')) return;
            this.workspaceDragPointerId = event.pointerId;
            this.workspaceDragStartX = event.clientX;
            this.workspaceDragStartY = event.clientY;
        }
        this.workspaceDragCandidateTabId = tab.id;
        this.workspaceDragOverTabId = '';
    }

    public async addWorkspaceTab(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.captureActiveWorkspaceScroll();
        const previousTabId = this.activeWorkspaceTabId;
        const tab = this.createWorkspaceTab(this.newWorkspaceTabUrl(), '새 탭');
        this.workspaceTabs.push(tab);
        this.activeWorkspaceTabId = tab.id;
        this.switchingWorkspaceTabs = true;
        this.beginWorkspaceSwitchVisual(tab.id);
        ReviewOpsWorkspaceRouterState.beginTabNavigation(previousTabId, tab.id);
        this.persistWorkspaceTabs();
        await this.navigateWorkspaceTab(tab.url, previousTabId);
    }

    public async activateWorkspaceTab(tab: ReviewOpsWorkspaceTab, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (tab && this.workspaceSuppressTabClickId === tab.id) {
            this.workspaceSuppressTabClickId = '';
            return;
        }
        if (!tab || tab.id === this.activeWorkspaceTabId) return;
        this.captureActiveWorkspaceScroll();
        const previousTabId = this.activeWorkspaceTabId;
        this.activeWorkspaceTabId = tab.id;
        this.switchingWorkspaceTabs = true;
        this.beginWorkspaceSwitchVisual(tab.id);
        ReviewOpsWorkspaceRouterState.beginTabNavigation(previousTabId, tab.id);
        this.persistWorkspaceTabs();
        await this.navigateWorkspaceTab(tab.url || this.newWorkspaceTabUrl(), previousTabId);
    }

    public async refreshActiveWorkspaceTab(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const activeTab = this.activeWorkspaceTab();
        if (!activeTab || !this.activeWorkspaceTabId || this.workspaceTabReloading) return;
        this.workspaceTabReloading = true;
        activeTab.scrollTop = 0;
        ReviewOpsWorkspaceRouterState.setActiveTab(this.activeWorkspaceTabId);
        this.beginWorkspaceSwitchVisual(this.activeWorkspaceTabId);
        ReviewOpsWorkspaceRouterState.refreshTab(this.activeWorkspaceTabId);
        this.persistWorkspaceTabs();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
        await this.service.render();
        window.setTimeout(async () => {
            if (this.destroyed) return;
            this.workspaceTabReloading = false;
            this.clearWorkspaceSwitchVisual();
            this.scheduleWorkspaceLayoutSync();
            this.scheduleHeaderSpacingSync();
            this.scheduleWorkspaceTitleSync();
            await this.service.render();
        }, 280);
    }

    public async closeWorkspaceTab(tab: ReviewOpsWorkspaceTab, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!tab || this.workspaceTabs.length <= 1) return;
        const closingIndex = this.workspaceTabs.findIndex((item: ReviewOpsWorkspaceTab) => item.id === tab.id);
        if (closingIndex < 0) return;
        const wasActive = tab.id === this.activeWorkspaceTabId;
        this.workspaceTabs.splice(closingIndex, 1);
        this.pruneWorkspaceTabCodexCounts();

        if (wasActive) {
            const nextTab = this.workspaceTabs[Math.max(0, closingIndex - 1)] || this.workspaceTabs[0];
            this.activeWorkspaceTabId = nextTab.id;
            this.switchingWorkspaceTabs = true;
            this.beginWorkspaceSwitchVisual(nextTab.id);
            ReviewOpsWorkspaceRouterState.beginTabNavigation(tab.id, nextTab.id);
            this.persistWorkspaceTabs();
            await this.navigateWorkspaceTab(nextTab.url || this.newWorkspaceTabUrl(), tab.id);
            ReviewOpsWorkspaceRouterState.dropTab(tab.id);
            return;
        }

        ReviewOpsWorkspaceRouterState.dropTab(tab.id);
        this.persistWorkspaceTabs();
        await this.service.render();
    }

    public async hideWorkspaceTabs(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.workspaceTabsHidden = true;
        this.clearWorkspaceTabCodexStatusPoll();
        this.saveWorkspaceTabsHidden();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
        await this.service.render();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
    }

    public async showWorkspaceTabs(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.workspaceTabsHidden = false;
        this.saveWorkspaceTabsHidden();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
        this.scheduleWorkspaceTabCodexStatusPoll(true);
        await this.service.render();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
    }

    public async toggleWorkspaceTabs(event?: Event) {
        if (this.workspaceTabsHidden) {
            await this.showWorkspaceTabs(event);
            return;
        }
        await this.hideWorkspaceTabs(event);
    }

    private loadSidebarCollapsed() {
        try {
            return window.localStorage.getItem(this.sidebarStorageKey) === 'true';
        } catch (error) {
            return false;
        }
    }

    private saveSidebarCollapsed() {
        try {
            window.localStorage.setItem(this.sidebarStorageKey, this.sidebarCollapsed ? 'true' : 'false');
        } catch (error) {
            return;
        }
    }

    private initializeWorkspaceTabs() {
        const tabs = this.loadWorkspaceTabs();
        const currentUrl = this.currentWorkspaceUrl();
        const activeTabId = this.loadActiveWorkspaceTabId();
        this.workspaceTabs = tabs.length ? tabs : [this.createWorkspaceTab(currentUrl, this.workspaceTabTitleForUrl(currentUrl))];
        let activeTab = this.workspaceTabs.find((tab: ReviewOpsWorkspaceTab) => tab.id === activeTabId) || this.workspaceTabs[0];
        const preserveTitle = this.shouldPreserveWorkspaceTabTitle(activeTab, currentUrl, false);
        activeTab.url = currentUrl;
        if (!preserveTitle) activeTab.title = this.workspaceTabTitleForUrl(currentUrl);
        this.activeWorkspaceTabId = activeTab.id;
        ReviewOpsWorkspaceRouterState.setActiveTab(this.activeWorkspaceTabId);
        this.persistWorkspaceTabs();
    }

    private createWorkspaceTab(url: string, title: string) {
        return {
            id: `tab-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`,
            title: title || this.workspaceTabTitleForUrl(url),
            url: url || this.newWorkspaceTabUrl(),
            scrollTop: 0,
            createdAt: Date.now()
        };
    }

    private loadWorkspaceTabs() {
        try {
            const raw = window.sessionStorage.getItem(this.workspaceTabsStorageKey);
            const parsed = raw ? JSON.parse(raw) : [];
            if (!Array.isArray(parsed)) return [];
            return parsed
                .filter((item: any) => item && item.id && item.url)
                .map((item: any) => {
                    const url = String(item.url || this.newWorkspaceTabUrl());
                    const fallbackTitle = this.workspaceTabTitleForUrl(url);
                    const title = this.isProjectDetailUrl(url) && item.title === '프로젝트'
                        ? fallbackTitle
                        : String(item.title || fallbackTitle);
                    return {
                        id: String(item.id),
                        title,
                        url,
                        scrollTop: Number(item.scrollTop || 0),
                        createdAt: Number(item.createdAt || Date.now())
                    };
                });
        } catch (error) {
            return [];
        }
    }

    private persistWorkspaceTabs() {
        try {
            window.sessionStorage.setItem(this.workspaceTabsStorageKey, JSON.stringify(this.workspaceTabs));
            window.sessionStorage.setItem(this.workspaceActiveTabStorageKey, this.activeWorkspaceTabId || '');
        } catch (error) {
            return;
        }
    }

    private loadActiveWorkspaceTabId() {
        try {
            return window.sessionStorage.getItem(this.workspaceActiveTabStorageKey) || '';
        } catch (error) {
            return '';
        }
    }

    private loadWorkspaceTabsHidden() {
        try {
            return window.localStorage.getItem(this.workspaceTabsHiddenStorageKey) === 'true';
        } catch (error) {
            return false;
        }
    }

    private saveWorkspaceTabsHidden() {
        try {
            window.localStorage.setItem(this.workspaceTabsHiddenStorageKey, this.workspaceTabsHidden ? 'true' : 'false');
        } catch (error) {
            return;
        }
    }

    private loadWorkspaceTabCodexCounts() {
        try {
            const raw = window.sessionStorage.getItem(this.workspaceTabCodexCountsStorageKey);
            const parsed = raw ? JSON.parse(raw) : null;
            if (!parsed || typeof parsed !== 'object') return {};
            const cachedAt = Number(parsed.cached_at || 0);
            if (!cachedAt || Date.now() - cachedAt > this.workspaceTabCodexCountsCacheMs) return {};
            const counts = parsed.counts && typeof parsed.counts === 'object' ? parsed.counts : {};
            const result: any = {};
            Object.keys(counts).forEach((projectId: string) => {
                const item = counts[projectId] || {};
                const running = this.workspaceCodexCountValue(item.running);
                const queued = this.workspaceCodexCountValue(item.queued);
                const total = this.workspaceCodexCountValue(item.total || running + queued);
                if (total > 0) result[projectId] = { total, running, queued };
            });
            return result;
        } catch (error) {
            return {};
        }
    }

    private persistWorkspaceTabCodexCounts() {
        try {
            window.sessionStorage.setItem(this.workspaceTabCodexCountsStorageKey, JSON.stringify({
                cached_at: Date.now(),
                counts: this.workspaceTabCodexCounts || {}
            }));
        } catch (error) {
            return;
        }
    }

    private currentWorkspaceUrl() {
        return `${window.location.pathname || '/'}${window.location.search || ''}${window.location.hash || ''}`;
    }

    private newWorkspaceTabUrl() {
        return '/projects/mine';
    }

    private activeWorkspaceTab() {
        return this.workspaceTabs.find((tab: ReviewOpsWorkspaceTab) => tab.id === this.activeWorkspaceTabId) || null;
    }

    private normalizeWorkspaceEventUrl(url: any) {
        const raw = String(url || '').trim();
        if (!raw) return this.currentWorkspaceUrl();
        try {
            const parsed = new URL(raw, window.location.origin);
            if (parsed.origin === window.location.origin) return `${parsed.pathname}${parsed.search}${parsed.hash}`;
        } catch (error) { }
        return raw.indexOf('/') === 0 ? raw : this.currentWorkspaceUrl();
    }

    private async updateActiveWorkspaceTabUrl(url: string) {
        const normalizedUrl = url || this.currentWorkspaceUrl();
        const activeTab = this.activeWorkspaceTab();
        if (!activeTab || activeTab.url === normalizedUrl) return;

        const previousUrl = activeTab.url || '';
        const preserveTitle = this.shouldPreserveWorkspaceTabTitle(activeTab, normalizedUrl, false);
        activeTab.url = normalizedUrl;
        if (!preserveTitle) activeTab.title = this.workspaceTabTitleForUrl(normalizedUrl);

        ReviewOpsWorkspaceRouterState.setActiveTab(this.activeWorkspaceTabId);
        this.persistWorkspaceTabs();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
        this.scheduleWorkspaceTitleSync();
        if (this.workspaceProjectIdFromUrl(previousUrl) !== this.workspaceProjectIdFromUrl(normalizedUrl)) {
            this.pruneWorkspaceTabCodexCounts();
            this.scheduleWorkspaceTabCodexStatusPoll(true);
        }
        await this.service.render();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
        this.scheduleWorkspaceTitleSync();
    }

    private async navigateWorkspaceTab(url: string, previousTabId: string) {
        try {
            const navigated = await this.router.navigateByUrl(url || this.newWorkspaceTabUrl());
            if (!navigated) await this.cancelWorkspaceTabNavigation(previousTabId);
        } catch (error) {
            await this.cancelWorkspaceTabNavigation(previousTabId);
        }
    }

    private async cancelWorkspaceTabNavigation(previousTabId: string) {
        if (previousTabId && this.workspaceTabs.some((tab: ReviewOpsWorkspaceTab) => tab.id === previousTabId)) {
            this.activeWorkspaceTabId = previousTabId;
        }
        this.switchingWorkspaceTabs = false;
        ReviewOpsWorkspaceRouterState.setActiveTab(this.activeWorkspaceTabId);
        ReviewOpsWorkspaceRouterState.finishTabNavigation();
        this.clearWorkspaceSwitchVisual(false);
        this.persistWorkspaceTabs();
        await this.service.render();
    }

    private beginWorkspaceSwitchVisual(tabId: string) {
        if (this.workspaceSwitchVisualTimer) {
            window.clearTimeout(this.workspaceSwitchVisualTimer);
            this.workspaceSwitchVisualTimer = undefined;
        }
        this.workspaceSwitchingTabId = tabId || '';
        this.workspaceSwitchVisualStartedAt = Date.now();
        this.applyWorkspaceSwitchVisual();
    }

    private finishWorkspaceSwitchVisual() {
        if (!this.workspaceSwitchingTabId) return;
        const elapsed = Date.now() - this.workspaceSwitchVisualStartedAt;
        const delay = Math.max(this.workspaceSwitchVisualMinMs - elapsed, 0);
        if (delay <= 0) {
            this.clearWorkspaceSwitchVisual(false);
            return;
        }
        if (this.workspaceSwitchVisualTimer) window.clearTimeout(this.workspaceSwitchVisualTimer);
        this.workspaceSwitchVisualTimer = window.setTimeout(async () => {
            this.workspaceSwitchVisualTimer = undefined;
            this.clearWorkspaceSwitchVisual(false);
            await this.service.render();
        }, delay);
    }

    private clearWorkspaceSwitchVisual(applyDom: boolean = true) {
        if (this.workspaceSwitchVisualTimer) {
            window.clearTimeout(this.workspaceSwitchVisualTimer);
            this.workspaceSwitchVisualTimer = undefined;
        }
        this.workspaceSwitchingTabId = '';
        this.workspaceSwitchVisualStartedAt = 0;
        if (applyDom) this.applyWorkspaceSwitchVisual();
    }

    private applyWorkspaceSwitchVisual() {
        window.requestAnimationFrame(() => {
            const tabId = this.workspaceSwitchingTabId;
            document.querySelectorAll('.reviewops-workspace-tab[data-workspace-tab-id]').forEach((element: Element) => {
                const item = element as HTMLElement;
                item.classList.toggle('is-switching', !!tabId && item.dataset.workspaceTabId === tabId);
            });
            const content = this.workspaceContentElement();
            if (content) content.classList.toggle('is-switching-tabs', !!tabId);
        });
    }

    private workspaceTabInsertIndexForClientX(clientX: number) {
        if (!this.draggingWorkspaceTabId) return -1;
        let insertIndex = 0;
        for (const tab of this.workspaceTabs) {
            if (!tab || tab.id === this.draggingWorkspaceTabId) continue;
            const element = document.querySelector(`.reviewops-workspace-tab[data-workspace-tab-id="${tab.id}"]`) as HTMLElement | null;
            if (!element) {
                insertIndex += 1;
                continue;
            }
            const rect = element.getBoundingClientRect();
            if (clientX < rect.left + rect.width / 2) return insertIndex;
            insertIndex += 1;
        }
        return insertIndex;
    }

    private autoScrollWorkspaceTabs(clientX: number) {
        const list = document.querySelector('.reviewops-workspace-tabs-list') as HTMLElement | null;
        if (!list || !list.getBoundingClientRect) return;
        const rect = list.getBoundingClientRect();
        const edgeSize = 56;
        const step = 18;
        if (clientX < rect.left + edgeSize) {
            list.scrollLeft -= step;
            return;
        }
        if (clientX > rect.right - edgeSize) {
            list.scrollLeft += step;
        }
    }

    private reorderWorkspaceTabToIndex(dragId: string, insertIndex: number) {
        const fromIndex = this.workspaceTabs.findIndex((tab: ReviewOpsWorkspaceTab) => tab.id === dragId);
        if (fromIndex < 0) return false;
        const nextIndex = Math.max(0, Math.min(insertIndex, this.workspaceTabs.length - 1));
        if (fromIndex === nextIndex) return false;

        const [draggedTab] = this.workspaceTabs.splice(fromIndex, 1);
        this.workspaceTabs.splice(nextIndex, 0, draggedTab);
        this.workspaceTabs = this.workspaceTabs.slice();
        return true;
    }

    private applyWorkspaceTabOrderStyles() {
        if (this.workspaceDragOrderFrame) return;
        this.workspaceDragOrderFrame = window.requestAnimationFrame(() => {
            this.workspaceDragOrderFrame = undefined;
            this.workspaceTabs.forEach((tab: ReviewOpsWorkspaceTab, index: number) => {
                const element = document.querySelector(`.reviewops-workspace-tab[data-workspace-tab-id="${tab.id}"]`) as HTMLElement | null;
                if (!element) return;
                element.style.order = String(index * 2);
                element.classList.toggle('is-dragging', !!this.draggingWorkspaceTabId && tab.id === this.draggingWorkspaceTabId);
                element.setAttribute('aria-grabbed', !!this.draggingWorkspaceTabId && tab.id === this.draggingWorkspaceTabId ? 'true' : 'false');
            });
            const list = document.querySelector('.reviewops-workspace-tabs-list') as HTMLElement | null;
            if (list) list.classList.toggle('is-reordering', !!this.draggingWorkspaceTabId);
            const addButton = document.querySelector('.reviewops-workspace-tab-add') as HTMLElement | null;
            if (addButton) addButton.style.order = String(this.workspaceAddButtonOrder());
        });
    }

    private async handleWorkspaceNavigationEnd(url: string) {
        const normalizedUrl = url || this.currentWorkspaceUrl();
        const activeTab = this.activeWorkspaceTab();
        const switchingTabs = this.switchingWorkspaceTabs;
        if (activeTab) {
            const preserveTitle = this.shouldPreserveWorkspaceTabTitle(activeTab, normalizedUrl, switchingTabs);
            activeTab.url = normalizedUrl;
            if (!preserveTitle) activeTab.title = this.workspaceTabTitleForUrl(normalizedUrl);
        }
        ReviewOpsWorkspaceRouterState.setActiveTab(this.activeWorkspaceTabId);
        ReviewOpsWorkspaceRouterState.finishTabNavigation();
        this.persistWorkspaceTabs();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
        this.scheduleWorkspaceTitleSync();
        if (!switchingTabs) this.scheduleWorkspaceTabCodexStatusPoll(true);
        if (switchingTabs) {
            this.restoreActiveWorkspaceScroll();
            this.switchingWorkspaceTabs = false;
            this.finishWorkspaceSwitchVisual();
        } else {
            this.clearWorkspaceSwitchVisual(false);
            this.resetWorkspaceScroll();
        }
        await this.service.render();
        this.scheduleWorkspaceLayoutSync();
        this.scheduleHeaderSpacingSync();
        this.scheduleWorkspaceTitleSync();
    }

    private captureActiveWorkspaceScroll() {
        const activeTab = this.activeWorkspaceTab();
        const content = activeTab ? this.workspaceScrollElement(activeTab.id) : this.workspaceContentElement();
        if (!activeTab || !content) return;
        activeTab.scrollTop = content.scrollTop || 0;
    }

    private restoreActiveWorkspaceScroll() {
        const activeTab = this.activeWorkspaceTab();
        if (!activeTab) return;
        window.requestAnimationFrame(() => {
            const content = this.workspaceScrollElement(activeTab.id);
            if (content) content.scrollTop = activeTab.scrollTop || 0;
        });
    }

    private resetWorkspaceScroll() {
        window.requestAnimationFrame(() => {
            const content = this.workspaceScrollElement();
            if (content) content.scrollTop = 0;
        });
    }

    private workspaceContentElement() {
        return document.querySelector('.reviewops-workspace-content') as HTMLElement | null;
    }

    private workspacePaneElement(tabId: string = this.activeWorkspaceTabId) {
        if (!tabId) return null;
        const panes = Array.prototype.slice.call(
            document.querySelectorAll('.reviewops-workspace-keepalive-pane[data-workspace-tab-id]')
        ) as HTMLElement[];
        for (let i = 0; i < panes.length; i++) {
            if (panes[i].dataset.workspaceTabId === tabId) return panes[i];
        }
        return null;
    }

    private workspaceScrollElement(tabId: string = this.activeWorkspaceTabId) {
        return this.workspacePaneElement(tabId) || this.workspaceContentElement();
    }

    private activeWorkspaceHeader() {
        const activePane = this.workspacePaneElement();
        if (activePane) {
            return activePane.querySelector('.reviewops-page-fixed-header') as HTMLElement | null;
        }

        const headers = Array.prototype.slice.call(
            document.querySelectorAll('.reviewops-page-fixed-header')
        ) as HTMLElement[];
        for (let i = 0; i < headers.length; i++) {
            if (this.isVisibleWorkspaceElement(headers[i])) return headers[i];
        }
        return headers.length ? headers[0] : null;
    }

    private isVisibleWorkspaceElement(element: HTMLElement) {
        let current: HTMLElement | null = element;
        while (current) {
            const style = window.getComputedStyle(current);
            if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
            current = current.parentElement;
        }
        return true;
    }

    private workspaceTabTitleForUrl(url: string) {
        const path = String(url || '').split(/[?#]/)[0] || '/';
        if (path === '/account') return '마이페이지';
        if (path.indexOf('/admin') === 0) return '관리자';
        if (path === '/projects') return '그룹 탐색';
        if (path === '/projects/mine') return '관리 그룹';
        if (path.indexOf('/projects/mine/group/') === 0) return '관리 그룹 상세';
        if (path === '/projects/participating') return '참여 그룹';
        if (path.indexOf('/projects/participating/group/') === 0) return '참여 그룹 상세';
        if (path.indexOf('/projects/group/') === 0) return '프로젝트 그룹 상세';
        if (path.indexOf('/projects/') === 0) return '프로젝트 로딩중';
        if (path === '/reviews/managed') return '관리 프로젝트';
        if (path === '/reviews/participating') return '참여 프로젝트';
        if (path === '/reviews/authored') return '내 리뷰 현황';
        if (path === '/reviews/authored-review') return '리뷰 검토';
        if (path === '/reviews/authored-closed') return '종결된 리뷰';
        if (path === '/reviews/task-new') return '신규 작업';
        if (path === '/reviews/task-active') return '진행중 작업';
        if (path === '/reviews/task-review') return '검증 대기 작업';
        if (path === '/reviews/task-closed') return '완료 작업';
        return '새 탭';
    }

    private shouldPreserveWorkspaceTabTitle(tab: ReviewOpsWorkspaceTab, url: string, switchingTabs: boolean) {
        if (!tab || !this.isProjectDetailUrl(url)) return false;
        const title = String(tab.title || '').trim();
        if (!title || ['프로젝트', '프로젝트 로딩중', '새 탭'].includes(title)) return false;
        if (switchingTabs) return true;
        const previousProjectId = this.workspaceProjectIdFromUrl(tab.url);
        const nextProjectId = this.workspaceProjectIdFromUrl(url);
        return !!previousProjectId && previousProjectId === nextProjectId;
    }

    private isProjectGroupUrl(url: string) {
        return url.indexOf('/projects/group/') === 0
            || url.indexOf('/projects/mine/group/') === 0
            || url.indexOf('/projects/participating/group/') === 0;
    }

    private isProjectDetailUrl(url: string) {
        return !!this.workspaceProjectIdFromUrl(url);
    }

    private workspaceProjectIdFromUrl(url: string) {
        const path = String(url || '').split(/[?#]/)[0] || '';
        const match = path.match(/^\/projects\/([^/?#]+)/);
        if (!match) return '';
        let projectId = '';
        try {
            projectId = decodeURIComponent(match[1] || '').trim();
        } catch (error) {
            projectId = String(match[1] || '').trim();
        }
        if (!projectId || ['group', 'mine', 'participating'].includes(projectId)) return '';
        return projectId;
    }

    private workspaceCodexCountValue(value: any) {
        const count = Number(value || 0);
        if (isNaN(count) || count < 0) return 0;
        return Math.floor(count);
    }

    private workspaceTabProjectIds() {
        const ids = (this.workspaceTabs || [])
            .map((tab: ReviewOpsWorkspaceTab) => this.workspaceProjectIdFromUrl(tab && tab.url ? tab.url : ''))
            .filter((projectId: string) => !!projectId);
        return Object.keys(ids.reduce((acc: any, projectId: string) => {
            acc[projectId] = true;
            return acc;
        }, {}));
    }

    private pruneWorkspaceTabCodexCounts() {
        if (!this.workspaceTabCodexCountsEnabled) {
            this.clearWorkspaceTabCodexCountsState(false);
            return;
        }
        const projectIds = this.workspaceTabProjectIds();
        const next: any = {};
        projectIds.forEach((projectId: string) => {
            if (this.workspaceTabCodexCounts[projectId]) next[projectId] = this.workspaceTabCodexCounts[projectId];
        });
        this.workspaceTabCodexCounts = next;
        this.persistWorkspaceTabCodexCounts();
    }

    private documentHidden() {
        return typeof document !== 'undefined' && !!document.hidden;
    }

    private workspaceTabCodexPollKey(projectIds: string[] = []) {
        return [...projectIds].sort().join('|');
    }

    private workspaceTabCodexCacheFresh(projectIds: string[] = []) {
        if (!this.workspaceTabCodexLastFetchAt) return false;
        if (this.workspaceTabCodexPollKey(projectIds) !== this.workspaceTabCodexLastFetchKey) return false;
        return Date.now() - this.workspaceTabCodexLastFetchAt < this.workspaceTabCodexCountsCacheMs;
    }

    private clearWorkspaceTabCodexStatusPoll() {
        if (!this.workspaceTabCodexPollTimer) return;
        window.clearTimeout(this.workspaceTabCodexPollTimer);
        this.workspaceTabCodexPollTimer = undefined;
    }

    private clearWorkspaceTabCodexCountsState(render: boolean = false) {
        this.clearWorkspaceTabCodexStatusPoll();
        this.workspaceTabCodexPolling = false;
        this.workspaceTabCodexLastFetchAt = 0;
        this.workspaceTabCodexLastFetchKey = '';
        const hadCounts = !!Object.keys(this.workspaceTabCodexCounts || {}).length;
        this.workspaceTabCodexCounts = {};
        this.persistWorkspaceTabCodexCounts();
        if (render && hadCounts) this.service.render();
    }

    private scheduleWorkspaceTabCodexStatusPoll(force: boolean = false) {
        this.clearWorkspaceTabCodexStatusPoll();
        if (!this.workspaceTabCodexCountsEnabled) {
            this.clearWorkspaceTabCodexCountsState(true);
            return;
        }
        if (this.destroyed || this.workspaceTabsHidden || this.documentHidden()) return;
        const projectIds = this.workspaceTabProjectIds();
        if (!projectIds.length) {
            if (Object.keys(this.workspaceTabCodexCounts || {}).length) {
                this.workspaceTabCodexCounts = {};
                this.persistWorkspaceTabCodexCounts();
                this.service.render();
            }
            return;
        }
        const delay = force && !this.workspaceTabCodexCacheFresh(projectIds) ? 0 : this.workspaceTabCodexPollIntervalMs;
        this.workspaceTabCodexPollTimer = window.setTimeout(() => {
            this.workspaceTabCodexPollTimer = undefined;
            this.refreshWorkspaceTabCodexCounts();
        }, delay);
    }

    private async refreshWorkspaceTabCodexCounts() {
        if (!this.workspaceTabCodexCountsEnabled) {
            this.clearWorkspaceTabCodexCountsState(true);
            return;
        }
        if (this.destroyed || this.workspaceTabsHidden || this.documentHidden()) return;
        const projectIds = this.workspaceTabProjectIds();
        if (!projectIds.length) {
            this.scheduleWorkspaceTabCodexStatusPoll(false);
            return;
        }
        if (this.workspaceTabCodexPolling) {
            this.scheduleWorkspaceTabCodexStatusPoll(false);
            return;
        }
        this.workspaceTabCodexPolling = true;
        this.workspaceTabCodexLastFetchAt = Date.now();
        this.workspaceTabCodexLastFetchKey = this.workspaceTabCodexPollKey(projectIds);
        try {
            const { code, data } = await wiz.call('codex_tab_counts', {
                project_ids: JSON.stringify(projectIds)
            });
            if (code === 200 && data && !this.destroyed) {
                this.applyWorkspaceTabCodexCounts(data.counts || {});
            }
        } catch (error) { }
        this.workspaceTabCodexPolling = false;
        this.scheduleWorkspaceTabCodexStatusPoll(false);
    }

    private applyWorkspaceTabCodexCounts(counts: any) {
        const next: any = {};
        this.workspaceTabProjectIds().forEach((projectId: string) => {
            const item = counts && counts[projectId] ? counts[projectId] : {};
            const running = this.workspaceCodexCountValue(item.running);
            const queued = this.workspaceCodexCountValue(item.queued);
            const total = this.workspaceCodexCountValue(item.total || running + queued);
            if (total > 0) next[projectId] = { total, running, queued };
        });
        if (JSON.stringify(this.workspaceTabCodexCounts || {}) === JSON.stringify(next)) return;
        this.workspaceTabCodexCounts = next;
        this.persistWorkspaceTabCodexCounts();
        if (!this.switchingWorkspaceTabs) this.service.render();
    }

    private scheduleWorkspaceTitleSync() {
        if (this.workspaceTitleTimer) window.clearTimeout(this.workspaceTitleTimer);
        this.workspaceTitleTimer = window.setTimeout(() => {
            this.workspaceTitleTimer = undefined;
            this.syncWorkspaceTitleFromHeader();
            window.setTimeout(() => this.syncWorkspaceTitleFromHeader(), 300);
        }, 80);
    }

    private syncWorkspaceTitleFromHeader() {
        const activeTab = this.activeWorkspaceTab();
        const header = this.activeWorkspaceHeader();
        const heading = header ? header.querySelector('h1') as HTMLElement | null : null;
        const title = heading && heading.innerText ? heading.innerText.trim() : '';
        if (!activeTab) return;
        if (this.isProjectDetailUrl(activeTab.url)) {
            if (!title || title === '프로젝트' || title === '프로젝트 로딩중' || activeTab.title === title) return;
            activeTab.title = title;
            this.persistWorkspaceTabs();
            this.service.render();
            return;
        }
        if (!title || activeTab.title === title) return;
        activeTab.title = title;
        this.persistWorkspaceTabs();
        this.service.render();
    }

    private installViewportHeightSync() {
        this.syncViewportHeight();
        const visualViewport = (window as any).visualViewport;
        if (!visualViewport) return;
        visualViewport.addEventListener('resize', this.viewportChangeHandler);
        visualViewport.addEventListener('scroll', this.viewportChangeHandler);
    }

    private scheduleViewportHeightSync() {
        if (this.viewportMeasureFrame) return;
        this.viewportMeasureFrame = window.requestAnimationFrame(() => {
            this.viewportMeasureFrame = undefined;
            this.syncViewportHeight();
        });
    }

    private syncViewportHeight() {
        const visualViewport = (window as any).visualViewport;
        const measuredHeight = Math.round((visualViewport && visualViewport.height) || window.innerHeight || 0);
        const height = measuredHeight > 0 ? measuredHeight : 320;
        const offsetTop = Math.max(Math.round((visualViewport && visualViewport.offsetTop) || 0), 0);
        document.documentElement.style.setProperty('--reviewops-viewport-height', `${height}px`);
        document.documentElement.style.setProperty('--reviewops-viewport-offset-top', `${offsetTop}px`);
    }

    private installHeaderSpacingSync() {
        if (this.headerMutationObserver) return;
        this.headerMutationObserver = new MutationObserver(() => {
            this.scheduleWorkspaceLayoutSync();
            this.scheduleHeaderSpacingSync();
            this.scheduleWorkspaceTitleSync();
        });
        this.headerMutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
        });
        this.scheduleHeaderSpacingSync();
    }

    private scheduleHeaderSpacingSync() {
        if (this.headerMeasureFrame) return;
        this.headerMeasureFrame = window.requestAnimationFrame(() => {
            this.headerMeasureFrame = undefined;
            this.syncHeaderSpacing();
        });
    }

    private scheduleWorkspaceLayoutSync() {
        if (this.workspaceLayoutFrame) return;
        this.workspaceLayoutFrame = window.requestAnimationFrame(() => {
            this.workspaceLayoutFrame = undefined;
            this.syncWorkspaceLayout();
        });
    }

    private syncWorkspaceLayout() {
        const tabbar = document.querySelector('.reviewops-workspace-tabs-bar') as HTMLElement | null;
        if (tabbar !== this.observedWorkspaceTabbar) this.observeWorkspaceTabbar(tabbar);
        const height = this.workspaceTabsHidden || !tabbar ? 0 : Math.ceil(tabbar.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--reviewops-workspace-tabbar-height', `${height}px`);
    }

    private syncHeaderSpacing() {
        const header = this.activeWorkspaceHeader();
        if (header !== this.observedHeader) this.observeHeader(header);
        if (!header) {
            document.documentElement.style.removeProperty('--reviewops-page-fixed-header-height');
            return;
        }
        const height = Math.ceil((header as HTMLElement).getBoundingClientRect().height);
        document.documentElement.style.setProperty('--reviewops-page-fixed-header-height', `${height}px`);
    }

    private observeHeader(header: Element | null) {
        if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
        this.observedHeader = header;
        if (!header || typeof ResizeObserver === 'undefined') return;
        this.headerResizeObserver = new ResizeObserver(() => this.scheduleHeaderSpacingSync());
        this.headerResizeObserver.observe(header);
    }

    private observeWorkspaceTabbar(tabbar: Element | null) {
        if (this.workspaceTabbarResizeObserver) this.workspaceTabbarResizeObserver.disconnect();
        this.observedWorkspaceTabbar = tabbar;
        if (!tabbar || typeof ResizeObserver === 'undefined') return;
        this.workspaceTabbarResizeObserver = new ResizeObserver(() => {
            this.scheduleWorkspaceLayoutSync();
            this.scheduleHeaderSpacingSync();
        });
        this.workspaceTabbarResizeObserver.observe(tabbar);
    }
}

export default LayoutSidebarComponent;